<template>
  <div class="bg-dark-create" :class="[showmodal ? 'open' : '']"></div>
  <div class="form-create-module edit_user" :class="[showmodal ? 'open' : '']">
    
    <div class="modal" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <Loader :isActive="!hasLoaded"></Loader>
          <div class="info-user" v-show="!updatePassword">
            <div class="modal-header">
              <h5 class="modal-title">{{ $t('admin.users.editUserTitle') }}</h5>
            </div>
            <div class="modal-body info-perfil-image mobile-img-container">
              <div class="form-group mobile-img">
                <div class="form-label">
                  <img class="temporary" src="../../../../assets/user.png" v-show="!userimagePreview && !userimage"/>
                  <img :src="userimagePreview? userimagePreview : userimage" alt="Logo" v-show="userimagePreview || userimage" />
                </div>
                <div class="form-label">
                  <div class="form-label">
                    <label>Imagem de Perfil</label>
                  </div>
                  <div class="form-file">
                    <div class="file-wrapper primary">
                      <span class="thumbnail">
                        <span class="icon">
                          <svg
                            width="46"
                            height="39"
                            viewBox="0 0 46 39"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M45 19.9308L36.7274 12.3475C36.1595 11.827 35.2948 11.8047 34.7009 12.2953L18.824 25.411C18.3196 25.8277 17.6074 25.8812 17.0464 25.5446L11.1009 21.9773C10.5893 21.6703 9.94666 21.6856 9.45024 22.0166L1 27.6501"
                              stroke="#9D9FA3"
                              stroke-width="1.25714"
                            ></path>
                            <rect
                              x="1.00049"
                              y="1.40454"
                              width="43.9461"
                              height="36.1909"
                              rx="2.58507"
                              stroke="#9D9FA3"
                              stroke-width="1.25714"
                            ></rect>
                            <circle
                              cx="14.8948"
                              cy="10.6676"
                              r="3.71629"
                              stroke="#9D9FA3"
                              stroke-width="1.25714"
                            ></circle>
                          </svg>
                        </span>
                        <span class="text">
                          Clique aqui para selecionar a imagem
                        </span>
                      </span>
                      <input class="form-control" type="file"  @change="updateFilePath"/>
                    </div>
                  </div>
                </div>
              
              </div>
            </div>
            <div class="modal-body double edit_user">
              <div class="form-group">
                <div class="form-label">
                  <label>
                    Nome  <v-tooltip :text="$t('common.requiredField')" location="top">
                      <template v-slot:activator="{ props }">
                        <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                      </template>
                    </v-tooltip>
                  </label>
                </div>
                <div class="form-input">
                  <input v-model="name" type="text" class="form-control" placeholder="Nome">
                </div>
              </div>

              <div class="form-group">
                <div class="form-label">
                  <label>
                    Eamil  <v-tooltip :text="$t('common.requiredField')" location="top">
                      <template v-slot:activator="{ props }">
                        <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                      </template>
                    </v-tooltip>
                  </label>
                </div>
                <div class="form-input">
                  <input v-model="email" type="text" class="form-control" placeholder="E-mail">
                </div>
              </div>
            </div>
            <div class="modal-body double">
              <div class="form-group">
                <div class="form-label">
                  <label>
                    CPF  <v-tooltip :text="$t('common.requiredField')" location="top">
                      <template v-slot:activator="{ props }">
                        <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                      </template>
                    </v-tooltip>
                  </label>
                </div>
                <div class="form-input">
                  <input v-model="cpf" type="text" class="form-control" placeholder="CPF"  v-mask="'###.###.###-##'">
                </div>
              </div>



              <div class="form-group">
                <div class="form-label">
                  <label>
                    Telefone  <v-tooltip :text="$t('common.requiredField')" location="top">
                      <template v-slot:activator="{ props }">
                        <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                      </template>
                    </v-tooltip>
                  </label>
                </div>
                <div class="form-input">
                  <input v-model="phone" type="text" class="form-control" placeholder="Telefone" v-mask="'(##) #.####-####'">
                </div>
              </div>

            </div>
            <div class="modal-body double">

              <div class="form-group">
                <div class="form-label">
                  <label>Identidade<v-tooltip :text="$t('common.requiredField')" location="top">
                    <template v-slot:activator="{ props }">
                      <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                    </template>
                  </v-tooltip></label>
                </div>
                <div class="form-input cep">
                  <input
                    v-model="idNumber"
                    type="text"
                    class="form-control"
                    placeholder="x.xxx-xxx"
                  />
                </div>
              </div>

              <div class="form-group">
                <div class="form-label">
                  <label> Tipo <v-tooltip :text="$t('common.requiredField')" location="top">
                    <template v-slot:activator="{ props }">
                      <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                    </template>
                  </v-tooltip></label>
                </div>
                <v-select
                  v-model="type"
                  :items="typeOptions"
                  item-title="text"
                  item-value="value"
                  label="Tipo"
                  variant="outlined"
                  density="compact"
                  hide-details
                  class="form-select"
                />
              </div>

              <div class="form-group">
                <div class="form-label">
                  <label> CEP <v-tooltip :text="$t('common.requiredField')" location="top">
                    <template v-slot:activator="{ props }">
                      <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                    </template>
                  </v-tooltip></label>
                </div>
                <div class="form-input cep">
                  <input
                    v-model="cep"
                    type="text"
                    class="form-control"
                    placeholder="xxxxx-xxx"
                    @change="getCEP()"
                    v-mask="'#####-###'"

                  />
                </div>
              </div>

            </div>
            <div class="modal-body double less">
              <div class="form-group">
                <div class="form-label">
                  <label>
                    Endereço  <v-tooltip :text="$t('common.requiredField')" location="top">
                      <template v-slot:activator="{ props }">
                        <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                      </template>
                    </v-tooltip>
                  </label>
                </div>
                <div class="form-input">
                  <input v-model="address" type="text" class="form-control" :placeholder="$t('admin.userForm.addressPlaceholder')">
                </div>
              </div>
              <div class="form-group">
                <div class="form-label">
                  <label>
                    Complemento  <v-tooltip :text="$t('common.requiredField')" location="top">
                      <template v-slot:activator="{ props }">
                        <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                      </template>
                    </v-tooltip>
                  </label>
                </div>
                <div class="form-input">
                  <input v-model="addressComplement" type="text" class="form-control" :placeholder="$t('admin.userForm.addressPlaceholder')">
                </div>
              </div>
              
              <div class="form-group">
                <div class="form-label">
                  <label>
                    Número  <v-tooltip :text="$t('common.requiredField')" location="top">
                      <template v-slot:activator="{ props }">
                        <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                      </template>
                    </v-tooltip>
                  </label>
                </div>
                <div class="form-input">
                  <input v-model="number" type="text" class="form-control" :placeholder="$t('admin.userForm.numberPlaceholder')">
                </div>
              </div>

            </div>

            <div class="modal-body double">
              
              <div class="form-group">
                <div class="form-label">
                  <label>
                    Cidade  <v-tooltip :text="$t('common.requiredField')" location="top">
                      <template v-slot:activator="{ props }">
                        <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                      </template>
                    </v-tooltip>
                  </label>
                </div>
                <div class="form-input">
                  <input v-model="city" type="text" class="form-control" placeholder="Cidade">
                </div>
              </div>

              <div class="form-group">
                <div class="form-label">
                  <label>
                    Estado  <v-tooltip :text="$t('common.requiredField')" location="top">
                      <template v-slot:activator="{ props }">
                        <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                      </template>
                    </v-tooltip>
                  </label>
                </div>
                <v-select
                  v-model="state"
                  :items="stateOptions"
                  item-title="text"
                  item-value="value"
                  label="Estado"
                  variant="outlined"
                  density="compact"
                  hide-details
                  class="form-select"
                />
                
              </div>

              <div class="form-group">
                <div class="form-label">
                  <label>
                    Pais  <v-tooltip :text="$t('common.requiredField')" location="top">
                      <template v-slot:activator="{ props }">
                        <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                      </template>
                    </v-tooltip>
                  </label>
                </div>
                <v-select
                  v-model="country"
                  :items="countryOptions"
                  item-title="text"
                  item-value="value"
                  :label="$t('admin.userForm.country')"
                  variant="outlined"
                  density="compact"
                  hide-details
                  class="form-select"
                />
              </div>
            </div>
        </div>
        <div class="info-user-paswword" v-show="updatePassword">
          <div class="modal-header">
            <h5 class="modal-title">Alterar Senha</h5>
          </div>
          <div class="modal-body double">
            <div class="form-group">
              <div class="form-label">
                <label>
                  Senha Atual
                  <v-tooltip :text="$t('common.requiredField')" location="top">
                    <template v-slot:activator="{ props }">
                      <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                    </template>
                  </v-tooltip>
                </label>
              </div>
              <div class="form-input">
                <input v-model="oldPassword" type="password" class="form-control" placeholder="Senha Atual">
              </div>
            </div>
          </div>
          <div class="modal-body double">
            <div class="form-group">
              <div class="form-label">
                <label>
                  Nova senha  <v-tooltip :text="$t('common.requiredField')" location="top">
                    <template v-slot:activator="{ props }">
                      <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                    </template>
                  </v-tooltip>
                </label>
              </div>
              <div class="form-input">
                <input v-model="password" type="password" class="form-control" placeholder="Nova senha">
              </div>
            </div>
            <div class="form-group">
              <div class="form-label">
                <label>
                  Confirme a nova senha  <v-tooltip :text="$t('common.requiredField')" location="top">
                    <template v-slot:activator="{ props }">
                      <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                    </template>
                  </v-tooltip>
                </label>
              </div>
              <div class="form-input">
                <input v-model="rePassword" type="password" class="form-control" placeholder="Confirmar nova senha">
              </div>
            </div>
          </div>
        </div>
          <div class="modal-footer">
            <button type="button" @click="closetab()" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
            <button type="button" @click="(()=>this.updatePassword=!this.updatePassword)" class="btn btn-secondary" data-bs-dismiss="modal">{{updatePassword==true? 'Alterar Dados':'Alterar Senha'}}</button>
            
            <button type="button" @click="saveModule()" class="btn btn-primary" v-show="!updatePassword">Salvar Dados</button>
            <button type="button" @click="changePassword()" class="btn btn-primary" v-show="updatePassword">Atualizar Senha</button>
          </div>
        </div>
      </div>
    </div>
    <v-dialog
    v-model="dialog"
    width="auto"
  >
    <v-card
      max-width="400"
      prepend-icon="mdi-update"
      :text="$t('common.formErrorsText')"
      :title="$t('common.formErrorsTitle')"
    >
      <template v-slot:actions>
        <v-btn
          class="ms-auto"
          text="Ok"
          @click="dialog = false"
        ></v-btn>
      </template>
    </v-card>
  </v-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import api from '@/utils/user'
import ApiCep from '@/utils/cep'
import Loader from '@/components/Loader/loader.vue';
import apiAWS from '@/utils/storage/aws';


export default {
  data() {
    return {
      hasLoaded: false,
      showmodal: '',
      name: '',
      email: '',
      cpf: '',
      phone: '',
      cep: '',
      address: '',
      number: '',
      city: '',
      state: '',
      country: '',
      county: '',
      password: '',
      rePassword: '',
      oldPassword: '',
      idUser: null,
      idNumber: null,
      userImgage:null,
      userimagePreview:null,
      addressComplement: '',
      hasLoad:false,
      dialog:false,
      updatePassword:false,
      typeOptions: [
        { text: 'Aluno', value: 3 },
        { text: 'Administrador', value: 2 }
      ],
      stateOptions: [
        { text: 'Selecione o estado', value: 'state' },
        { text: 'Acre', value: 'Acre' },
        { text: 'Alagoas', value: 'Alagoas' },
        { text: 'Amapá', value: 'Amapá' },
        { text: 'Amazonas', value: 'Amazonas' },
        { text: 'Bahia', value: 'Bahia' },
        { text: 'Ceará', value: 'Ceará' },
        { text: 'Distrito Federal', value: 'Distrito Federal' },
        { text: 'Espírito Santo', value: 'Espírito Santo' },
        { text: 'Goiás', value: 'Goiás' },
        { text: 'Maranhão', value: 'Maranhão' },
        { text: 'Mato Grosso', value: 'Mato Grosso' },
        { text: 'Mato Grosso do Sul', value: 'Mato Grosso do Sul' },
        { text: 'Minas Gerais', value: 'Minas Gerais' },
        { text: 'Pará', value: 'Pará' },
        { text: 'Paraíba', value: 'Paraíba' },
        { text: 'Paraná', value: 'Paraná' },
        { text: 'Pernambuco', value: 'Pernambuco' },
        { text: 'Piauí', value: 'Piauí' },
        { text: 'Rio de Janeiro', value: 'Rio de Janeiro' },
        { text: 'Rio Grande do Norte', value: 'Rio Grande do Norte' },
        { text: 'Rio Grande do Sul', value: 'Rio Grande do Sul' },
        { text: 'Rondônia', value: 'Rondônia' },
        { text: 'Roraima', value: 'Roraima' },
        { text: 'Santa Catarina', value: 'Santa Catarina' },
        { text: 'São Paulo', value: 'São Paulo' },
        { text: 'Sergipe', value: 'Sergipe' },
        { text: 'Tocantins', value: 'Tocantins' },
        { text: 'Outros', value: 'Outros' }
      ],
      countryOptions: [
        { text: 'Brasil', value: 'br' },
        { text: 'Outro', value: 'outro' }
      ],
      states: [
        "Acre",
        "Alagoas",
        "Amapá",
        "Amazonas",
        "Bahia",
        "Ceará",
        "Distrito Federal",
        "Espírito Santo",
        "Goiás",
        "Maranhão",
        "Mato Grosso",
        "Mato Grosso do Sul",
        "Minas Gerais",
        "Pará",
        "Paraíba",
        "Paraná",
        "Pernambuco",
        "Piauí",
        "Rio de Janeiro",
        "Rio Grande do Norte",
        "Rio Grande do Sul",
        "Rondônia",
        "Roraima",
        "Santa Catarina",
        "São Paulo",
        "Sergipe",
        "Tocantins",
        "Outros"
      ],
    }
  },
  props: {
    show: Boolean,
    id: Number
  },
  components:{
    Loader
  },
  computed: {
    ...mapState(['token'])
  },
  methods: {
    async getDataUser() {
      this.hasLoaded=false;
      try {
        const response = await api.getDataUser(this.id, this.token);
        this.name = response.name;
        this.email = response.email;
        this.cpf = response.socialNumber;
        this.phone = response.phone;
        this.cep = response.postcode;
        this.type = response.type;
        this.address = response.address;
        this.number = response.addressNumber;
        this.city = response.city;
        this.state = response.county;
        this.country = response.country;
        this.county = response.county;
        this.idNumber = response.idNumber;
        this.addressComplement = response.addressComplement;
        this.hasLoaded=true;
        this.userImgage  = response.photoFinal;
        this.userimagePreview = response.photoFinal;
      } catch (error) {
        console.error("Erro ao caregar dados de usuário", error)
      }
    },
    async validateFields() {
      if (!this.name || !this.email || !this.cpf || !this.phone || !this.cep || !this.address || !this.number || !this.city || !this.state || !this.country || !this.password || !this.repassword) {
        this.dialog = true;
        return false; 
      }
      return true; 
    },
    async editUser(){
        const obj = {
        "name": this.name,
        "email": this.email,
        "phone": this.phone,
        "socialNumber": this.cpf,
        "idNumber": this.idNumber,
        "county": this.state,
        "country": this.country,
        "city": this.city,
        "address": this.address,
        "addressNumber": this.number,
        "addressComplement": this.addressComplement,
        "postcode": this.cep,
        "username": this.email,
        "type": this.type,
        "status": 1,
        "photo": this.userImgage
      }
      try {
        const response = await api.EditUser(obj, this.token, this.id);
        window.location.reload();

      } catch (error) {
        console.error('Erro ao eidtar o usuário', error)
      }
    },
    closetab() {
      this.hasLoaded = false;

      this.showmodal = false;
      this.updatePassword = false;
      this.$emit('open-tab', this.showmodal)
    },
    opentab() {
      this.show = true,
        this.$emit('open-tab', this.showmodal)
    },
    async saveModule() {
      this.updatePassword = false;
        this.editUser();
        this.showmodal = false;
        this.$emit('open-tab', this.showmodal);
        this.nameModule = null;
        this.demo = null;
    },
    async putFileAws(url, file){
      try {
          const response = await apiAWS.putFileAWS(url, file);
      } catch (error) {
          console.error('Erro ao enviar arquivo para AWS');
      }
    },
  async updateFilePath(event){
      const file = event.target.files[0];
      this.userimagePreview = URL.createObjectURL(file)

      const formData = new FormData();
      formData.append('file', this.userimage);

      try {
          const response =  await apiAWS.getSignatureImage(this.token, file.name);
          this.putFileAws(response.url, file)
          this.userImgage = response.token;
      } catch (error) {
          console.error('Erro na geração do TOKEN AWS')
      }
  },
    async changePassword(){
      if(this.password!=this.rePassword){
        alert('As senhas devem ser iguais');
        return false;
      }
      const obj = {
        "oldPassword": this.oldPassword,
        "newPassword": this.password
      }
      try {
        const response = api.changePassword(obj, this.token);
        this.showmodal = false;
        this.$emit('open-tab', this.showmodal);
      } catch (error) {
        console.error(error)
      }
    },
    async getCEP(){
      try {
        const response = await ApiCep.getDataCep(this.cep);
        console.debug(response);
        this.city = response.city;  
        this.address = response.street;
        const state = response.state;
        if (this.states.includes(state)) {
          this.state = state;
          this.country = 'br';
        } else {
          this.state = "Outros";
          this.country = 'outro';
        }

      } catch (error) {
        console.error('Erro ao gerar dados do cep');
      }
    }
  },
  created() {
    if(this.show==true){
      this.getDataUser();
    }
    
  },

  watch: {
    show(novoValor) {
      this.showmodal = this.show;
      this.idUser = this.id
      this.getDataUser();
    },
  }
}
</script>
<style scoped>
@import './edituser.css';
</style>
